import Color from 'color';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FaceIcon from 'LegacyWeployDesignLanguage/icons/FaceIcon';

const SMALL = 'SMALL';
const MEDIUM = 'MEDIUM';
const LARGE = 'LARGE';

const styles = {
  [SMALL]: '56px',
  [MEDIUM]: '72px',
  [LARGE]: '136px',
};

const IconWrapper = styled.div`
  width: ${props => props.size};
  height: ${props => props.size};
  background-color: ${props => Color(props.theme.colors.text.secondary).alpha(0.08).string()};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    color: ${props => props.theme.colors.text.secondary}; /* Override MaterialUI styling */
    fill: ${props => props.theme.colors.text.secondary};
    width: calc(${props => props.size} / 2);
    height: calc(${props => props.size} / 2);
  }
`;

const IconContainer = ({ svg, size }) => (
  <IconWrapper size={styles[size]}>
    {svg}
  </IconWrapper>
);

IconContainer.propTypes = {
  size: PropTypes.string,
  svg: PropTypes.node,
};

IconContainer.defaultProps = {
  size: SMALL,
  svg: <FaceIcon />,
};

IconContainer.SMALL = SMALL;
IconContainer.MEDIUM = MEDIUM;
IconContainer.LARGE = LARGE;

export default IconContainer;
